var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGallery(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 193,
    viewBox: "0 0 256 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M249.5 1H6.5C3.46243 1 1 3.46243 1 6.5V186.5C1 189.538 3.46243 192 6.5 192H249.5C252.538 192 255 189.538 255 186.5V6.5C255 3.46243 252.538 1 249.5 1Z",
    stroke: "#718095"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 61,
    width: 92,
    height: 82,
    rx: 5,
    fill: "#718095",
    fillOpacity: 0.35
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 61,
    width: 21,
    height: 82,
    rx: 5,
    fill: "#718095",
    fillOpacity: 0.35
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 61,
    width: 21,
    height: 82,
    rx: 5,
    fill: "#718095",
    fillOpacity: 0.35
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 61,
    width: 21,
    height: 82,
    rx: 5,
    fill: "#718095",
    fillOpacity: 0.35
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 68,
    width: 78,
    height: 68,
    rx: 3,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 74,
    width: 66,
    height: 57,
    rx: 3,
    fill: "#718095"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 32,
    width: 61,
    height: 6,
    rx: 3,
    fill: "#D1D5DB"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 41,
    width: 110,
    height: 2,
    rx: 1,
    fill: "#3C4148"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 44,
    width: 81,
    height: 2,
    rx: 1,
    fill: "#3C4148"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.32870470d689b0a3ba57d1697b24b2e7.svg";
export { ForwardRef as ReactComponent };